import { Check, Clock, Droplet, Zap } from "lucide-react";
import { Tables } from "@/integrations/supabase/types";

type ReadingHeaderProps = {
  type: Tables<"readings">["type"];
  houseName: string;
  readingDate: string;
  status: string;
};

export const ReadingHeader = ({ type, houseName, readingDate, status }: ReadingHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-3">
        {type === 'water' ? (
          <Droplet className="w-5 h-5 text-blue-500" />
        ) : (
          <Zap className="w-5 h-5 text-yellow-500" />
        )}
        <div>
          <h3 className="font-semibold">{houseName}</h3>
          <p className="text-sm text-gray-600">{readingDate}</p>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <div className={`p-2 rounded-full ${
          status === 'completed' 
            ? 'bg-secondary text-secondary-foreground' 
            : 'bg-accent text-accent-foreground'
        }`}>
          {status === 'completed' ? (
            <Check className="w-4 h-4" />
          ) : (
            <Clock className="w-4 h-4" />
          )}
        </div>
      </div>
    </div>
  );
};